<template>
  <div
    ref="flashcard-view-container"
    class="flashcard-view-container"
  >
    <flashcard-header
      :answered="answered"
      :breadcrumbs="breadcrumbs"
      :category="currentFlashcardCategory"
      :flashcard="currentFlashcard"
    />
    <flashcard
      :answered="answered"
      :answer-ids="answerIds"
      :category="currentFlashcardCategory"
      :correct="correct"
      :flashcard="currentFlashcard"
      :raw-answer-data="rawAnswerData"
      :terminology="isTerminology"
      @set-answer-ids="setAnswerIds"
      @set-raw-answer-data="setRawAnswerData"
    />
    <flashcard-footer
      :answered="answered"
      :answer-ids="answerIds"
      :category="currentFlashcardCategory"
      :correct="correct"
      :flashcard="currentFlashcard"
      :raw-answer-data="rawAnswerData"
      :terminology="isTerminology"
      :show-bookmark="true"
      @nextFlashcard="goToNextFlashcard"
      @answer="answerFlashcard"
    />
  </div>
</template>

<script>

import Flashcard from '@components/flashcards/flashcard';
import FlashcardFooter from '@components/flashcards/footer';
import FlashcardHeader from '@components/flashcards/header';

import GlobalMixin from '@/mixins/global';
import FlashcardViewMixin from '@/mixins/flashcardViews';
import RateLimitMixin from '@/mixins/rate-limit';

export default {
  components: { Flashcard, FlashcardFooter, FlashcardHeader },
  mixins: [FlashcardViewMixin, GlobalMixin, RateLimitMixin],
  computed: {
    breadcrumbs() {
      let crumbs = [{ name: 'Search', route: { name: 'search#index', query: { q: this.$route.query.q } } }];
      if (this.currentFlashcardCategory) {
        crumbs.push({ name: this.currentFlashcardCategory.name, route: {}});
      }

      return crumbs;
    },
    currentFlashcardCategory() {
      if (this.currentFlashcard.id) {
        // just return first multiple choice category id
        let categories = this.currentFlashcard.categoryIds.map(id => this.$store.getters['categories/categories'][id]);
        let types = this.$store.getters['categoryTypes/multipleChoiceCategoryTypes'].map(ct => ct.id);
        return categories.find(c => types.includes(c.categoryTypeId));
      }
    },
    nextFlashcardRoute() {
      if (this.nextFlashcard) {
        return { name: 'search#flashcard', params: { flashcardId: this.nextFlashcard }, query: { q: this.$route.query.q } };
      } else {
        return { name: 'search#index', query: { q: this.$route.query.q } };
      }
    },
  },
  watch: {
    '$route.params.flashcardId': function(id) {
      if(!this.$store.getters['flashcards/flashcards'][id]) {
        let params = { ids: [id] };
        this.$store.dispatch('flashcards/fetchFlashcards', params);
      }
    },
    'currentFlashcard.id': {
      immediate: true,
      handler: function(id) {
        this.resetFlashcard(id);
      },
    },
  },
  created() {
    let stateParams = ['flashcards', 'stats'];
    this.$store.dispatch('flashcardStates/fetchStates', stateParams);
    let params = {};

    if (this.$route.query.q) {
      params.q = this.$route.query.q;
    }

    if (this.$route.params.flashcardId) {
      params.flashcardId = this.$route.params.flashcardId;
    }
    params.rateLimited = this.rateLimitingEnabled;

    this.sessionPromise = this.$store.dispatch('flashcards/createFlashcardSession', params);
  },
  mounted() {
    this.sessionPromise.then(flashcard => {
      if (!flashcard) {
        this.$router.go(-1);
      }
    }).catch(e => {
      this.$router.go(-1);
      Promise.reject(e);
    });
  },
};
</script>

<style lang='scss' scoped>
  .flashcard-view-container {
    @include flashcard-view;
  }
</style>
